export { PreferencesPanel } from './PreferencesPanel';
export type { PreferencesPanelProps, PreferenceCategory } from './PreferencesPanel.types';
